<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', RESOURCE)"
        v-b-toggle.sidebar-create-confirmed-scientific-topic
        variant="primary"
        @click="create"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>

    <template #cell(apply_doc)="{ data }">
      {{ applyDocLabel(data.value) }}
    </template>

    <template #cell(protocol)="{ data }">
      {{ protocolLabel(data.value) }}
    </template>
  </l-table>
</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import confirmedScientificTopicModule from '@/store/confirmed-scientific-topic/index'
import Create from './Create.vue'
import config from './config'
import LTable from '@/views/components/LTable.vue'

const RESOURCE = 'ScientificTopicProtocol'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    Create,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
  },
  methods: {
    create() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    applyDocLabel(applyDoc) {
      return applyDoc?.fio || '-'
    },
    protocolLabel(protocol) {
      return protocol?.protocol_number || '-'
    },
  },
  setup() {
    const MODULE_NAME = 'confirmedScientificTopic'

    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, confirmedScientificTopicModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      RESOURCE,
      ...config(),
    }
  },
}
</script>
